import { useQuery } from '@apollo/client/react';
import { t } from '@lingui/core/macro';
import { DialogState } from 'shared/domains/common-ui/DialogState';
import { SendForApprovalModalWrapperDocument } from './SendForApprovalModalWrapper.gql';
import { SendForVoluntaryApprovalModal } from '../../../SendForVoluntaryApprovalModal';
export function SendForApprovalModalWrapper(props) {
    const { type, approvers, onClose } = props;
    const teamIds = approvers.filter((approver) => approver.type === 'team').map((approver) => approver.id);
    const { data, loading, error, refetch } = useQuery(SendForApprovalModalWrapperDocument, {
        variables: { teamIds },
        skip: !teamIds.length,
    });
    const isValidTeamMember = (member) => Boolean(member);
    const teams = (data === null || data === void 0 ? void 0 : data.teams) || [];
    const teamMembers = teams.map((team) => { var _a; return (_a = team.members) !== null && _a !== void 0 ? _a : []; }).flat();
    const teamMemberUsers = teamMembers
        .map((member) => {
        if (!member.user) {
            return null;
        }
        return {
            id: member.user.id,
            name: member.user.name || t({ message: 'Deleted user', comment: 'Fallback name when user does not exist' }),
        };
    })
        .filter(isValidTeamMember);
    const nonTeamUsers = approvers
        .filter((approver) => approver.type === 'user')
        .map((approver) => ({
        id: approver.id,
        name: approver.name,
    }));
    const uniqueSelectedUsers = [...nonTeamUsers, ...teamMemberUsers]
        .filter((approver, index, self) => self.findIndex((a) => a.id === approver.id) === index)
        .map((user) => ({
        userId: user.id,
        name: user.name,
    }));
    return (<DialogState state={{ loading, error: Boolean(error) }} onClose={onClose} onRefetch={refetch}>
      <SendForVoluntaryApprovalModal approvalType={type} selectedApprovers={uniqueSelectedUsers} onClose={onClose}/>
    </DialogState>);
}
